<template>
    <div class="card">
        <div class="card_input_box">
            <input type="number" placeholder="请输入您的卡号" v-model="form_data.card_num" :disabled="form_data.disabled" @input="cardInputChange"/>
        </div>

        <div class="card_product_box" v-if="product_data.length > 0">
            <div class="card_product_item" v-for="(item, index) in product_data" v:key="index">
                <div>
                    <img class="card_product_pic" :src="item.image"/>
                </div>
                <div class="card_product_txt checkbox-wrapper">
                    <label class="well-check">
                        <input type="checkbox" :value="item.id" v-model="check_product_data"/><i
                            class="checkbox_icon icon"></i><span class="checkbox_txt">{{item.store_name}}</span>
                    </label>
                </div>
            </div>
        </div>

        <div class="card_product_btn" v-show="product_data.length > 0">
            <button @click="saveProduct">确认</button>
        </div>

        <div class="card_score_box" v-if="score_data.show">
            <div>卡券余额：{{score_data.score}}</div>
            <button @click="saveScore">兑换</button>
        </div>

        <div class="card_msg_box" v-show="msg_data.show">
            <div class="card_msg_bg"></div>
            <div class="card_msg">
                <img class="card_msg_pic" src="@assets/images/card_pic.png"/>
                <div class="card_msg_info">
                    <div class="card_msg_txt">
                        {{msg_data.text}}
                    </div>
                    <button class="card_msg_btn" @click="callBack(msg_data.btn_call)">{{msg_data.btn_text}}</button>
                </div>
                <div class="card_msg_close_box" @click="closeMsg">
                    <span class="card_msg_close iconfont icon-iconfontguanbi"></span>
                </div>
            </div>
        </div>

        <div class="card_form_box" v-if="card_data.show">
            <div class="card_form_bg"></div>
            <div class="card_form">
                <div class="card_form_tab" v-if="has_store">
                    <div v-bind:class="['card_form_tab_item', 'item1', {'on': (card_data.type == 0)}]" data-index="0" @click="cardChangeType"></div>
                    <div v-bind:class="['card_form_tab_item', 'item2', {'on': (card_data.type == 1)}]" data-index="1" @click="cardChangeType"></div>
                </div>      
                <div class="card_form_data data1" v-bind:style="[{'margin-top': has_store ? '0.75rem' : '0'}, {'border-radius': has_store ? '0 0 0.1rem 0.1rem' : '0.1rem'}]" v-if="card_data.type == 0">     
                    <div class='card_form_item'>
                        <div class='name'>姓名</div>
                        <input type='text' placeholder='请输入姓名' v-model="card_data.tote_data.name"></input>
                    </div>
                    <div class='card_form_item'>
                        <div class='name'>联系电话</div>
                        <input type='text' placeholder='请输入联系电话' v-model="card_data.tote_data.phone"></input>
                    </div>
                    <div class='card_form_item' v-if="address_ready">
                        <div class='name'>所在地区</div>
                        <div class='card_form_picker'>
                            <div class="picker" slot="right" @click.stop="address_show = true">
                            {{ address_text || "请选择收货地址" }}
                            </div>
                        </div>
                        <div class="iconfont icon-dizhi font-color-red"></div>
                    </div>
                    <div class='card_form_item'>
                        <div class='name'>详细地址</div>
                        <input type='text' placeholder='请填写具体地址' v-model="card_data.tote_data.address"></input>
                    </div>
                    <div class='card_form_item'>
                        <div class='name'>期望发货时间</div>
                        <DateTime class="card_form_time" type="date" v-model="card_data.tote_data.tote_date" placeholder="请选择期望发货时间" :start-date="tote_start_date"></DateTime>
                    </div>
                    <div class="card_form_btn">
                        <button class='card_form_btn1' @click="saveCard">确认</button>
                        <button class='card_form_btn2' @click="closeCard">关闭</button>
                    </div>
                </div>
                <div class="card_form_data data2" v-bind:style="[{'margin-top': has_store ? '0.75rem' : '0'}, {'border-radius': has_store ? '0 0 0.1rem 0.1rem' : '0.1rem'}]" v-if="card_data.type == 1">
                    <div class='card_form_item' style="padding-top: 0.5rem" v-if="store_show">
                        <div class='name'>提货门店</div>
                        <select class="card_form_time" v-model="card_data.store_data.store_id">
                            <option v-for="(item, index) in storeData" :value="item.id" :key="index">
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                    <div v-else class="wait_text">加载中...</div>
                    <div class="card_form_btn">
                        <button class='card_form_btn1' @click="saveCard">确认</button>
                        <button class='card_form_btn2' @click="closeCard">关闭</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="card_pwd_box" v-if="pwd_show">
            <div class="card_pwd_bg"></div>
            <div class="card_pwd">
                <div class="card_pwd_info">
                    <input type='text' placeholder='请输入卡密' v-model="form_data.card_pwd"></input>
                    <div class="card_form_btn">
                        <button class='card_form_btn1' @click="checkPwd">确认</button>
                        <button class='card_form_btn2' @click="closePwd">关闭</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="card_text">
            <div>使用须知</div>
            <div>1.本卡用于兑换“浦农优鲜”商城所有在售商品，有效期一年.</div>
            <div>2.扫描右侧二维码，点击兑换，输入卡号和密码，兑换等值商品.</div>
            <div>3.所兑换商品享受“浦农优鲜”商城同等优惠和服务.</div>
            <div>4.卡片一经发出，不接受补卡、退卡、找零.</div>
        </div>

        <CitySelect ref="cityselect" v-model="address_show" :callback="addressChange" :items="addressData" :ready="address_ready" provance="" city="" area=""></CitySelect>
    </div>
</template>

<script>
    import {getUser, getMenuUser} from "@api/user";
    import {getHasStore, searchCard, saveCard, checkPwd, saveCardScore} from "@api/card";
    import { storeListApi } from "@api/store";
    import { getCity } from "@api/public";
    import { isWeixin } from "@utils/index";
    import { wechatEvevt, wxShowLocation } from "@libs/wechat";
    import cookie from "@utils/store/cookie";
    import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
    import { DateTime } from 'vue-ydui/dist/lib.rem/datetime';
    import { mapGetters } from "vuex";

    const NAME = "Card";
    const LONGITUDE = "user_longitude";
    const LATITUDE = "user_latitude";
    const MAPKEY = "mapKey";

    export default {
        name: NAME,
        components: {
            CitySelect,
            DateTime
        },
        computed: mapGetters(['userInfo']),
        props: {},
        data: function () {
            return {
                form_data: {
                    card_num: '',
                    card_pwd: '',
                    pwd_is_true: false,
                    card_max: 0,
                    disabled: false
                },
                product_data: [],
                can_count: 0,
                score_data: {
                    show: false,
                    score: 0
                },
                msg_data: {
                    show: false,
                    text: '',
                    btn_text: '',
                    btn_call: 'closeMsg'
                },
                check_product_data: [],
                card_data: {
                    show: false,
                    type: 0, // 提货类型 0：快递；1：门店
                    tote_data: {
                        name: '',
                        phone: '',
                        address: '',
                        tote_date: ''
                    },
                    store_data: {
                        store_id: 0
                    }
                },
                has_store: false,
                region: ['省', '市', '区'],
                area_id: 0,
                address_show: false,
                address_ready: false,
                addressData: [],
                address_text: '',
                tote_start_date: '',
                store_show: false,
                storeData: [],
                storeIndex: 0,
                mapKey: cookie.get(MAPKEY),
                pwd_show: false
            };
        },
        watch: {},
        mounted: function () {
            let that = this;
            let date = that.getNowFormatDate();
            that.form_data.card_max = 5;
            that.tote_start_date = date;
            that.card_data.tote_data.tote_date = date;
            that.getCardInfo();
        },
        beforeRouteEnter(to, from, next) {
            window.document.body.style.backgroundColor = '#FFF';
            next();
        },
        beforeRouteLeave(to, from, next) {
            window.document.body.style.backgroundColor = '';
            next();
        },
        methods: {
            getNowFormatDate: function () {
                var date = new Date();
                var seperator1 = '-';
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = '0' + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = '0' + strDate;
                }
                var currentdate = year + seperator1 + month + seperator1 + strDate;
                return currentdate;
            },
            getCardInfo: function () {
                let that = this;
                getHasStore().then(res => {
                    that.has_store = res.msg == 1 ? true : false;
                })
                getCity().then(res => {
                    that.address_ready = true;
                    that.addressData = res.data;
                })
            },
            addressChange: function (res) {
                let that = this;
                that.region = [res.itemName1, res.itemName2, res.itemName3];
                that.area_id = res.itemValue3;
                that.address_text = that.region.join(' ');
            },
            cardInputChange: function () {
                let that = this;
                let card_num = that.form_data.card_num;
                if (card_num.length >= that.form_data.card_max) {
                    that.form_data.card_num = card_num.slice(0, that.form_data.card_max)
                    if (!that.form_data.disabled) {
                        that.form_data.disabled = !that.form_data.disabled
                        that.searchData();
                    }
                }
            },
            searchData: function () {
                let that = this;
                let card_num = that.form_data.card_num;
                that.$dialog.loading.open('查询中');
                that.product_data = [];
                that.score_data = {
                    show: false,
                    score: 0
                };
                that.check_product_data = [];
                that.form_data.card_pwd = '';
                that.form_data.pwd_is_true = false;
                searchCard(card_num).then(res => {
                    if (res.msg == '积分') {
                        that.score_data.show = !that.score_data.show;
                        that.score_data.score = res.data.score;
                    } else {
                        that.product_data = res.data.product_data;
                        that.can_count = res.data.can_count;
                    }
                    that.form_data.disabled = !that.form_data.disabled;
                    that.$dialog.loading.close();
                }).catch((err) => {
                    let res = {text: err.msg, btn_text: '确定', btn_call: 'closeMsg'}
                    that.form_data.disabled = !that.form_data.disabled;
                    that.msg_data.show = !that.msg_data.show;
                    that.msg_data.text = res.text;
                    that.msg_data.btn_text = res.btn_text;
                    that.msg_data.btn_call = res.btn_call;
                    that.$dialog.loading.close();
                });
            },
            callBack: function (callBack) {
                this[callBack]();
            },
            closeMsg: function () {
                let that = this
                that.msg_data.show = !that.msg_data.show
            },
            goList: function () {
                let that = this;
                that.closeMsg();
                console.log('goList')
            },
            saveProduct: function () {
                let that = this;
                if (that.check_product_data.length == 0) {
                    let res = {text: '请选择卡券商品', btn_text: '确定', btn_call: 'closeMsg'}
                    that.msg_data.show = !that.msg_data.show;
                    that.msg_data.text = res.text;
                    that.msg_data.btn_text = res.btn_text;
                    that.msg_data.btn_call = res.btn_call;
                } else if (that.can_count < that.check_product_data.length) {
                    let res = {text: '可兑换数仅剩' + that.can_count + '个', btn_text: '确定', btn_call: 'closeMsg'}
                    that.msg_data.show = !that.msg_data.show;
                    that.msg_data.text = res.text;
                    that.msg_data.btn_text = res.btn_text;
                    that.msg_data.btn_call = res.btn_call;
                } else {
                    if (that.form_data.pwd_is_true) {
                        that.card_data.show = !that.card_data.show;
                    } else {
                        that.pwd_show = !that.pwd_show;
                    }
                }
            },
            saveScore: function () {
                let that = this;
                if (that.form_data.pwd_is_true) {
                    that.saveCardScore();
                } else {
                    that.pwd_show = !that.pwd_show;
                }
            },
            checkPwd: function () {
                let that = this;
                if (that.form_data.card_pwd == '') {
                    that.msg_data.show = !that.msg_data.show;
                    that.msg_data.text = '请输入卡密';
                    that.msg_data.btn_text = '确定';
                    that.msg_data.btn_call = 'closeMsg';
                    return false;
                }
                let data = {};
                data.card = that.form_data.card_num
                data.pwd = that.form_data.card_pwd
                checkPwd(data).then(res => {
                    that.form_data.pwd_is_true = true;
                    that.pwd_show = !that.pwd_show;
                    if (that.score_data.show) {
                        that.saveCardScore();
                    } else {
                        that.card_data.show = !that.card_data.show;
                    }
                }).catch((err) => {
                    let res = {text: err.msg, btn_text: '确定', btn_call: 'closeMsg'}
                    that.msg_data.show = !that.msg_data.show;
                    that.msg_data.text = res.text;
                    that.msg_data.btn_text = res.btn_text;
                    that.msg_data.btn_call = res.btn_call;
                    that.$dialog.loading.close();
                });
            },
            closePwd: function () {
                let that = this
                that.pwd_show = !that.pwd_show;
            },
            saveCardScore: function () {
                let data = {}, that = this;
                data.uid = that.userInfo.uid;
                data.card = that.form_data.card_num;
                data.pwd = that.form_data.card_pwd;
                that.$dialog.loading.open('提交中');
                saveCardScore(data).then(res => {
                    let msg = res.msg;
                    let msg_res = {text: msg, btn_text: '确定', btn_call: 'cardScoreSuccess'};
                    that.msg_data.show = !that.msg_data.show;
                    that.msg_data.text = msg_res.text;
                    that.msg_data.btn_text = msg_res.btn_text;
                    that.msg_data.btn_call = msg_res.btn_call;
                    that.$dialog.loading.close();
                }).catch((err) => {
                    let res = {text: err.msg, btn_text: '确定', btn_call: 'closeMsg'}
                    that.msg_data.show = !that.msg_data.show;
                    that.msg_data.text = res.text;
                    that.msg_data.btn_text = res.btn_text;
                    that.msg_data.btn_call = res.btn_call;
                    that.$dialog.loading.close();
                });
            },
            cardScoreSuccess: function () {
                let that = this
                that.form_data.card_num = '';
                that.form_data.card_pwd = '';
                that.form_data.pwd_is_true = false;
                that.product_data = [];
                that.score_data = {
                    show: false,
                    score: 0
                };
                that.check_product_data = [];
                that.closeMsg();
                that.$router.push({ path: '/user' });
            },
            saveCard: function () {
                let data = {}, that = this;
                data.uid = that.userInfo.uid;
                data.number = that.form_data.card_num;
                data.pwd = that.form_data.card_pwd;
                data.product_ids = that.check_product_data;
                data.type = that.card_data.type;
                data.tote_data = that.card_data.tote_data;
                data.tote_data.region = that.region;
                data.tote_data.area_id = that.area_id;
                data.store_data = that.card_data.store_data;
                // console.log(JSON.stringify(data));
                if (data.type == 0) {
                    if (data.tote_data.name == '') {
                        that.msg_data.show = !that.msg_data.show;
                        that.msg_data.text = '请输入姓名';
                        that.msg_data.btn_text = '确定';
                        that.msg_data.btn_call = 'closeMsg';
                        return false;
                    }
                    if (data.tote_data.phone == '') {
                        that.msg_data.show = !that.msg_data.show;
                        that.msg_data.text = '请输入联系电话';
                        that.msg_data.btn_text = '确定';
                        that.msg_data.btn_call = 'closeMsg';
                        return false;
                    }
                    let reg = /^1[3456789]\d{9}$/;
                    if (!reg.test(data.tote_data.phone)) {
                        that.msg_data.show = !that.msg_data.show;
                        that.msg_data.text = '请输入正确的联系电话';
                        that.msg_data.btn_text = '确定';
                        that.msg_data.btn_call = 'closeMsg';
                        return false;
                    }
                    if (data.tote_data.area_id == 0) {
                        that.msg_data.show = !that.msg_data.show;
                        that.msg_data.text = '请选择所在地区';
                        that.msg_data.btn_text = '确定';
                        that.msg_data.btn_call = 'closeMsg';
                        return false;
                    }
                    if (data.tote_data.address == '') {
                        that.msg_data.show = !that.msg_data.show;
                        that.msg_data.text = '请输入具体地址';
                        that.msg_data.btn_text = '确定';
                        that.msg_data.btn_call = 'closeMsg';
                        return false;
                    }
                } else {
                    if (data.store_data.store_id == 0) {
                        that.msg_data.show = !that.msg_data.show;
                        that.msg_data.text = '请选择提货门店';
                        that.msg_data.btn_text = '确定';
                        that.msg_data.btn_call = 'closeMsg';
                        return false;
                    }
                }
                that.$dialog.loading.open('提交中');
                saveCard(data).then(res => {
                    let msg = res.msg;
                    let msg_res = {text: msg, btn_text: '确定', btn_call: 'cardSuccess'};
                    that.msg_data.show = !that.msg_data.show;
                    that.msg_data.text = msg_res.text;
                    that.msg_data.btn_text = msg_res.btn_text;
                    that.msg_data.btn_call = msg_res.btn_call;
                    that.$dialog.loading.close();
                }).catch((err) => {
                    let res = {text: err.msg, btn_text: '确定', btn_call: 'closeMsg'}
                    that.msg_data.show = !that.msg_data.show;
                    that.msg_data.text = res.text;
                    that.msg_data.btn_text = res.btn_text;
                    that.msg_data.btn_call = res.btn_call;
                    that.$dialog.loading.close();
                });
            },
            cardSuccess: function () {
                let that = this
                that.form_data.card_num = '';
                that.form_data.card_pwd = '';
                that.form_data.pwd_is_true = false;
                that.product_data = [];
                that.score_data = {
                    show: false,
                    score: 0
                };
                that.check_product_data = [];
                that.closeMsg();
                that.closeCard();
                that.$router.push({ path: '/user' });
            },
            closeCard: function () {
                let that = this
                that.card_data.show = !that.card_data.show;
            },
            cardChangeType: function (e) {
                let index = e.currentTarget.dataset.index;
                let that = this;
                that.card_data.type = parseInt(index);
                if (index == 1) {
                    if (cookie.get(LONGITUDE) && cookie.get(LATITUDE)) {
                        this.getList();
                    } else {
                        this.selfLocation();
                    }
                }
            },
            selfLocation: function () {
                let that = this;
                if (isWeixin()) {
                    wxShowLocation().then(res => {
                        that.getList();
                    })
                    .catch(err => {
                        that.$dialog.error(err.msg);
                        that.getList();
                    });
                } else {
                    that.getList();
                }
            },
            getList: function () {
                let data = {
                    latitude: cookie.get(LATITUDE) || '',
                    longitude: cookie.get(LONGITUDE) || '',
                    page: 1,
                    limit: 10
                }, that = this;
                storeListApi(data).then(res => {
                    let list = res.data.list || [];
                    that.storeData = list;
                    that.store_show = true;
                    that.card_data.store_data.store_id = list ? list[0].id : 0;
                });
            }
        }
    };
</script>

<style scoped>
    .card {
        padding: 0.2rem;
    }

    .card_input_box {
        margin-top: 1rem;
    }

    .card_input_box > input {
        border: 1px solid #979797;
        border-radius: 0.1rem;
        height: 0.8rem;
        line-height: 0.8rem;
        padding: 0 0.2rem;
        width: 100%;
    }

    .card_msg_box {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        z-index: 999;
    }

    .card_msg_bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background-color: #000;
        opacity: 0.3;
    }

    .card_msg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 85%;
        background-color: #FFF;
        border-radius: 0.1rem;
    }

    .card_msg_pic {
        position: absolute;
        top: -35%;
        left: 50%;
        transform: translate(-50%, 0);
        width: 50vw;
    }

    .card_msg_info {
        margin: 1.3rem 0 0.3rem;
        text-align: center;
    }

    .card_msg_txt {
        padding: 0.7rem;
        font-size: 0.4rem;
        color: #3A3A3A;
    }

    .card_msg_btn {
        background-color: #FF5200 !important;
        width: 60%;
        margin: 0 auto;
        height: 0.7rem;
        line-height: 0.7rem;
        border-radius: 0.7rem;
        color: #FFF;
        font-weight: 600;
    }

    .card_msg_close_box {
        position: absolute;
        background-color: #DEDEDE;
        width: 0.5rem;
        height: 0.5rem;
        line-height: 0.5rem;
        top: -0.2rem;
        right: -0.2rem;
        border-radius: 50%;
        text-align: center;
    }

    .card_msg_close {
        color: #FFF;
        font-size: 0.3rem;
    }

    .card_product_box {
        overflow: hidden;
    }

    .card_product_item {
        width: 50%;
        float: left;
        margin-top: 0.5rem;
        text-align: center;
    }

    .card_product_pic {
        width: 90%;
        height: 3rem;
        border-radius: 0.1rem;
    }

    .card_product_txt {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
    }

    .checkbox .wx-checkbox-input {
        border-radius: 0.1rem;
    }

    .checkbox_icon {
        position: relative;
        transform: translate(0, 0);
        -webkit-transform: translate(0, 0);
        border-radius: 0.1rem;
        margin-right: 0.1rem;
    }

    .checkbox_txt {
        font-size: 0.3rem;
    }

    .card_product_btn {
        margin: 0.5rem 0;
    }

    .card_product_btn > button {
        background-color: #FF5200 !important;
        height: 0.7rem;
        line-height: 0.7rem;
        width: 100%;
        border-radius: 0.1rem;
        color: #FFF;
        font-weight: 600;
    }

    .card_form_box {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        z-index: 888;
    }

    .card_form_bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background-color: #000;
        opacity: 0.3;
    }

    .card_form {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 95%;
        border-radius: 0.1rem;
    }

    .card_form_tab {
        display: flex;
        flex-wrap: wrap;
    }

    .card_form_tab_item {
        position: absolute;
        width: 100%;
        height: 0.8rem;
    }

    .card_form_tab_item.item1::before {
        position: absolute;
        bottom: 0;
        content: "快递配送";
        font-size: 0.28rem;
        display: block;
        height: 0;
        width: 50%;
        border-width: 0 0.6rem 0.6rem 0;
        border-style: none solid solid;
        border-color: transparent transparent #F0F0F0;
        border-radius: 0.06rem 0.4rem 0 0;
        text-align: center;
        line-height: 0.6rem;
        z-index: 1;
        letter-spacing: 0.02rem;
    }
    .card_form_tab_item.item1.on::before {
        z-index: 2;
        width: 60%;
        border-width: 0 0.2rem 0.8rem 0;
        border-style: none solid solid;
        border-color: transparent transparent #FFF;
        line-height: 0.8rem;
    }
    .card_form_tab_item.item2::before {
        position: absolute;
        bottom: 0;
        right: 0;
        content: "到店自提";
        font-size: 0.28rem;
        display: block;
        height: 0;
        width: 50%;
        border-width: 0 0 0.6rem 0.6rem;
        border-style: none solid solid;
        border-color: transparent transparent #F0F0F0;
        border-radius: 0.4rem 0.06rem 0 0;
        text-align: center;
        line-height: 0.6rem;
        z-index: 1;
        letter-spacing: 0.02rem;
    }
    .card_form_tab_item.item2.on::before {
        z-index: 2;
        width: 60%;
        border-width: 0 0 0.8rem 0.2rem;
        border-radius: 0.3rem 0.07rem 0 0;
        border-color: transparent transparent #FFF;
        line-height: 0.8rem;
    }
    .card_form_data {
        background-color: #FFF;
        padding-bottom: 0.5rem;
    }
    .card_form_item {
        display: flex;
        flex-wrap: wrap;
        padding: 0 0.3rem;
        height: 0.9rem;
        align-items: center;
        justify-content: space-between;
    }
    .card_form_item:nth-child(n+2) {
        border-top: 0.01rem solid #eee;
    }
    .card_form_item .name {
        width: 1.95rem;
        font-size: 0.3rem;
        color: #666;
    }
    .card_form_item input {
        flex-grow: 1;
        font-size: 0.3rem;
    }
    .card_form_picker {
        flex-grow: 1;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
    }
    .card_form_picker .picker {
        width: 4.1rem;
        font-size: 0.3rem;
    }
    .card_form_time {
        flex-grow: 1;
        width: auto;
        font-size: 0.3rem;
    }
    .card_form_btn {
        margin: 0.5rem auto 0;
        overflow: hidden;
        padding: 0 0.2rem;
    }
    .card_form_btn1 {
        float: left;
        width: 45%;
        background-color: #FF5200!important;
        height: 0.7rem;
        line-height: 0.7rem;
        border-radius: 0.7rem;
        color: #FFF;
        font-weight: 600;
    }
    .card_form_btn2 {
        float: right;
        width: 45%;
        background-color: #999!important;
        height: 0.7rem;
        line-height: 0.7rem;
        border-radius: 0.7rem;
        color: #FFF;
        font-weight: 600;
    }
    .wait_text {
        padding-top: 0.5rem;
        text-align: center;
    }

    .card_pwd_box {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        z-index: 777;
    }
    .card_pwd_bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background-color: #000;
        opacity: 0.3;
    }
    .card_pwd {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 95%;
        border-radius: 0.1rem;
        background-color: #FFF;
    }
    .card_pwd_info {
        margin: 0.3rem 0;
        text-align: center;
    }
    .card_pwd_info > input {
        border: 1px solid #939393;
        width: 90%;
        padding: 0.3rem 0.1rem;
        border-radius: 0.1rem;
    }
    .card_score_box {
        padding: 0.5rem 0;
        text-align: center;
    }
    .card_score_box > div {
        font-size: 0.5rem;
    }
    .card_score_box > button {
        margin-top: 0.3rem;
        background-color: #FF5200 !important;
        height: 0.7rem;
        line-height: 0.7rem;
        width: 100%;
        border-radius: 0.1rem;
        color: #FFF;
        font-weight: 600;
    }
    .card_text {
        padding: 0.5rem 0.2rem;
    }
    .card_text  > div {
        line-height: 0.5rem;
    }
</style>
